import React from 'react';
import logoSource from '../../assets/hotel.svg';
import Carousel, { Modal, ModalGateway } from 'react-images';
import { Button, CircularProgress } from 'material-ui';
import PhotoIcon from 'material-ui-icons/Photo';
import { translate } from 'react-i18next';
import { isValidImage } from '../Utils/shared';
import _get from 'lodash.get';

/**
 * Este Render toma el DTO hotel y loopea el array de imagenes.
 * TODO: las imagenes son de 800 x 532 :/
 * 
 */
class HotelImagesRender extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            img: null,
            defaultImage: logoSource,
            imageWidth: 240,
            imageHeight: 200,
            isOpen: false,
            whitelist: [],
            whitelistDone: false,
        };
    }

    componentDidUpdate(prevProps) {

        const prev = _get(prevProps, 'hotel.code', null);
        const current = _get(this.props, 'hotel.code', null);

        if (prev !== current) {
            this.setState(() => ({
                loading: true,
                whitelist: [],
                whitelistDone: false,
            }), () => this.resolveWhitelist());
        }
    }

    toggle = () => {
        this.setState(state => ({
            isOpen: !state.isOpen,
        }));
    };

    openModal = async () => {
        this.setState({
            isOpen: true,
        });
    };

    onNextProps(nextProps) {
        if (nextProps && nextProps.imageWidth) {
            this.setState({ imageWidth: nextProps.imageWidth });
        }
        if (nextProps && nextProps.imageHeight) {
            this.setState({ imageHeight: nextProps.imageHeight });
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.onNextProps(nextProps);
    }


    initializeImages() {
        const { whitelist } = this.state;

        if (whitelist && whitelist.length > 1) {
            return; // alreadyInitialized
        }
        if (whitelist && whitelist.length > 0) {
            //seteo o borro el timer
            this.setState({ img: whitelist[0] });
            this.position = 1;
        }
    }

    componentDidMount() {
        this.onNextProps(this.props);
        this.resolveWhitelist();
    }

    getImages(props) {

        const { hotel } = props;
        const images = hotel ? (hotel.images || []) : [];

        return images;
    }

    componentWillUnmount() {
        clearInterval(this.myVar);
        this.myVar = null;
    }

    resolveWhitelist() {

        const { whitelistDone } = this.state;
        const images = this.getImages(this.props);
        if (!images || !images.length > 0 || whitelistDone) {
            return;
        }
        this.setState({ img: this.state.defaultImage });
        images.map((url, index) => isValidImage(url)
            .then((valid) => {
                if (valid) {
                    this.setState(state => ({
                        loading: false,
                        whitelist: [...state.whitelist, url],
                    }));

                    this.initializeImages();
                }

                if (index === images.length - 1) {
                    this.setState({
                        loading: false,
                        whitelistDone: true,
                    });
                }
            }));
    }

    render() {
        const styleFn = styleObj => ({ ...styleObj, zIndex: 10000 });
        const { isOpen, whitelist } = this.state;
        const { t } = this.props;

        const source = whitelist.map(val => {
            return { src: val };
        });

        const hasImages = source && source.length > 0;
        return (
            
            <div style={{height: '100%'}}>
                <div className="cmsHotelImg" >
                    {this.state.loading 
                        ? <CircularProgress className="cmsHotelPicture" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} /> 
                        : <React.Fragment>
                        
                            <div className="imageContainer" ref="myRef" style={{
                                width: this.state.imageWidth + 'px',
                                height: this.state.imageHeight + 'px',
                                backgroundRepeat: 'no-repeat',
                                backgroundSize: this.state.img ? 'cover' : 'initial',
                                transition: 'background-image 1s ease-in-out',
                                backgroundPosition: 'center center',
                                backgroundImage: this.state.img ? 'url("' + this.state.img + '")' : '',
                            }}></div>

                        </React.Fragment>
                    }


                    <Button onClick={() => this.openModal()}>
                        <icon><PhotoIcon /></icon>
                    </Button>
                </div>

                <ModalGateway>
                    {hasImages && isOpen ? (
                        <Modal onClose={this.toggle} styles={{ blanket: styleFn, positioner: styleFn }}>
                            <Carousel
                                views={source}
                                modalProps={{ allowFullscreen: false, isFullscreen: false }}
                            />
                        </Modal>
                    ) : null}
                </ModalGateway>
            </div >
        );
    }
}
export default translate('translations')(HotelImagesRender);


// WEBPACK FOOTER //
// ./src/components/Reservation/HotelImagesRender.js